import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "popup-delete-register" }
const _hoisted_2 = { class: "text-2xl mb-4 text-color-333" }
const _hoisted_3 = { class: "mb-6 text-color-333" }
const _hoisted_4 = { class: "flex justify-end" }
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { class: "cp-icon-close text-4xl" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "cp-icon-trash text-2xl" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_Modal = _resolveComponent("Modal")

  return (_openBlock(), _createBlock(_component_Modal, {
    modelValue: _ctx.isShow,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.isShow = $event)),
    width: "460px",
    noScrollBody: ""
  }, {
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, _toDisplayString(_ctx.t('deleteRegistered')), 1),
        _createVNode("div", _hoisted_3, _toDisplayString(_ctx.t('messageDeleteRegister')), 1),
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_Button, {
            onClick: _ctx.handleCancel,
            variant: "outline-primary",
            class: "mr-4"
          }, {
            default: _withCtx(() => [
              _hoisted_5,
              _createTextVNode(" " + _toDisplayString(_ctx.t('overtimeRegister.buttonCancel')), 1)
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_Button, {
            onClick: _ctx.handleSubmitIcCardNumber,
            variant: "danger"
          }, {
            default: _withCtx(() => [
              _hoisted_6,
              _createTextVNode(" " + _toDisplayString(_ctx.t('actionDelete')), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}